import { MenuItemBase } from "./menu-item-base";
/**
 * An item of the menu.
 */
export function MenuItem(props) {
    return <MenuItemBase role="menuitem" closeOnSelect {...props}/>;
}
